import { AxiosInstance } from 'axios';
import axiosClient from './axiosClientConfig';
import { HttpResponse } from '@/interfaces';

class ChatAI {
	constructor(private client: AxiosInstance) {}
	async postChatMessage(data: {
		content: string;
	}): Promise<HttpResponse<{ message: string }>> {
		return this.client.post('/chat-bot', data);
	}
}

export const chatAIService = new ChatAI(axiosClient);
